const footerLinks = {
  navigation: [
    { label: '首页', href: '#hero' },
    { label: '热门推荐', href: '#cards' },
    { label: '更新动态', href: '#updates' },
    { label: '读者热评', href: '#comments' },
    { label: '专题合集', href: '#index' },
    { label: '常见问答', href: '#faq' },
  ],
  categories: [
    { label: '奇幻冒险', href: '#cards' },
    { label: '科幻异种', href: '#cards' },
    { label: '都市传说', href: '#cards' },
    { label: '热血战斗', href: '#cards' },
    { label: '校园奇幻', href: '#cards' },
    { label: '太空歌剧', href: '#cards' },
  ],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="max-w-7xl mx-auto pt-16 pb-8 px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <span className="text-xl md:text-2xl font-heading font-bold text-white">
              触手漫画
            </span>
            <p className="text-sm text-foreground-400 mt-4 leading-relaxed">
              触手漫画网——专注触手题材漫画的免费在线阅读平台。
              提供下拉式畅快浏览体验，海量触手漫画全集实时更新，
              触手漫画在线看免费阅读，无需下载，随时随地畅读你喜爱的触手漫画。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">题材分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作品牌与平台信息即将上线，敬请期待。如有合作意向，欢迎通过联系我们模块与我们取得联系。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 触手漫画网. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-300 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-300 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}